import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import type { NavItem } from "@/components/nav/types/nav";

type NavMenuItemProps = {
  item: NavItem;
  isActive: boolean;
  onNavigate: (to: string) => void;
};

export function NavMenuItem({ item, isActive, onNavigate }: NavMenuItemProps) {
  return (
    <SidebarMenuItem>
      <SidebarMenuButton tooltip={item.label} isActive={isActive} onClick={() => onNavigate(item.to)}>
        <item.icon />
        <span>{item.label}</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
